import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    {
      path: 'add-showcase-error',
      name: 'add-showcase-error',
      component: () => import(/* webpackChunkName: "add-showcase-error" */ '@/views/h5/add-showcase/error')
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: false, notShowDialog: true } }))

export default pages
